var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.isVisible)?_c('div',{staticClass:"wrapper"},[_c('div',{staticClass:"text"},[_vm._v(_vm._s(_vm.targetGroup.name))]),_c('div',{staticClass:"suffix"},[_vm._v("グループを編集中")])]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }